// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-map {
  height: 100%;
  width: 100%;
  display: flex;
}
wm-map .map-container {
  flex-grow: 1;
  height: 100%;
  position: relative;
}
wm-map .map-container > .bottom-right {
  position: absolute;
  right: calc(16px + constant(safe-area-inset-right));
  right: calc(16px + env(safe-area-inset-right));
  bottom: 40px;
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: center;
  z-index: 1;
}
wm-map .map-container > .bottom-right > *:not(:empty) {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  margin-bottom: 10px;
}
wm-map .map-container > .bottom-right ion-fab {
  position: relative;
  display: block;
  left: 0;
  top: 0;
}
wm-map .map-container > .bottom-right ion-fab-button,
wm-map .map-container > .bottom-right .wm-btn-track-recording {
  height: 42px;
  width: 42px;
  margin: 0 0 16px 10px;
}
wm-map .map-container > .bottom-center {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 40px;
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: center;
  z-index: 2;
}
wm-map .map-container > .bottom-center > * {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  margin-bottom: 10px;
}
wm-map .map-container > .bottom-center ion-fab {
  position: relative;
}
wm-map .map-container > .bottom-center ion-fab-button,
wm-map .map-container > .bottom-center .wm-btn-track-recording {
  height: 42px;
  width: 42px;
  margin: 7px;
}
wm-map .map-container > .bottom {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 4px;
  z-index: 2;
  display: inline-flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
}
wm-map .map-container > .bottom > * {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  margin-left: 10px;
}
wm-map .map-container > .top-right {
  position: absolute;
  right: calc(16px + constant(safe-area-inset-right));
  right: calc(16px + env(safe-area-inset-right));
  top: calc(16px + constant(safe-area-inset-top));
  top: calc(16px + env(safe-area-inset-top));
  z-index: 2;
  display: inline-flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
}
wm-map .map-container > .top-right > *:not(:empty) {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  margin-left: 10px;
}
wm-map .map-container > .top-left {
  position: absolute;
  left: 22px;
  top: constant(safe-area-inset-top, 30px);
  top: env(safe-area-inset-top, 30px);
  z-index: 2;
  display: inline-flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
}
wm-map .map-container > .top-left > * {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  margin-left: 10px;
}
wm-map .map-container .wm-map-delete-bounding-box-button {
  width: 40px;
  height: 40px;
  margin: 0;
  --background: var(--wm-color-light);
  --border-radius: 20px;
  --padding-start: 10px;
  --padding-end: 10px;
  animation: slideIn 0.3s ease-out;
}
wm-map .map-container .ol-zoom {
  position: absolute;
  top: 50%;
  right: 20px;
  left: 16px;
  width: fit-content;
  height: auto;
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  overflow: hidden;
}
wm-map .map-container .ol-zoom button {
  margin: 0;
  height: 40px;
  width: 40px;
  font-size: 28px;
}
wm-map .map-container .ol-zoom button:hover, wm-map .map-container .ol-zoom button:focus {
  outline: none;
}
wm-map .map-container #webmapp-map-scale-line-container {
  position: absolute;
  bottom: 11px;
  left: 0;
  width: 100px;
  z-index: 1;
}
wm-map .map-container #webmapp-map-attribution-container {
  position: absolute;
  bottom: 20px;
  right: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  border-radius: 5px;
  transition: bottom 500ms;
  z-index: 1;
  background: rgba(var(--wm-color-light-rgb), 0.75);
  box-shadow: -1px -1px 5px -3px var(--wm-color-dark);
}
wm-map .map-container #webmapp-map-attribution-container .webmapp-map-attribution {
  display: inline-block;
  font-size: var(--font-sm);
}
wm-map .map-container #webmapp-map-attribution-container .webmapp-map-attribution .webmapp-map-attribution-link {
  --ion-margin: 6px;
  color: var(--wm-color-dark);
  text-decoration: none;
}
wm-map canvas {
  position: absolute;
}

@keyframes slideIn {
  0% {
    transform: translateY(15px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/map-core/src/components/map/map.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,aAAA;AACF;AACE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAAI;EACE,kBAAA;EACA,mDAAA;EACA,8CAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;AAEN;AADM;EACE,QAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAGR;AADM;EACE,kBAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;AAGR;AADM;;EAEE,YAAA;EACA,WAAA;EACA,qBAAA;AAGR;AAAI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;AAEN;AADM;EACE,QAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAGR;AADM;EACE,kBAAA;AAGR;AADM;;EAEE,YAAA;EACA,WAAA;EACA,WAAA;AAGR;AAAI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAEN;AADM;EACE,QAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAGR;AAAI;EACE,kBAAA;EACA,mDAAA;EACA,8CAAA;EACA,+CAAA;EACA,0CAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAEN;AADM;EACE,QAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAGR;AAAI;EACE,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,mCAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAEN;AADM;EACE,QAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAGR;AAAI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mCAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;AAEN;AAAI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;AAEN;AAAM;EACE,SAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAER;AAAQ;EAEE,aAAA;AACV;AAGI;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;AADN;AAGI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,iDAAA;EACA,mDAAA;AADN;AAEM;EACE,qBAAA;EACA,yBAAA;AAAR;AACQ;EACE,iBAAA;EACA,2BAAA;EACA,qBAAA;AACV;AAIE;EACE,kBAAA;AAFJ;;AAMA;EACE;IACE,2BAAA;IACA,UAAA;EAHF;EAKA;IACE,wBAAA;IACA,UAAA;EAHF;AACF","sourcesContent":["wm-map {\n  height: 100%;\n  width: 100%;\n  display: flex;\n\n  .map-container {\n    flex-grow: 1;\n    height: 100%;\n    position: relative;\n    > .bottom-right {\n      position: absolute;\n      right: calc(16px + constant(safe-area-inset-right));\n      right: calc(16px + env(safe-area-inset-right));\n      bottom: 40px;\n      display: inline-flex;\n      flex-direction: column;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: center;\n      z-index: 1;\n      > *:not(:empty) {\n        order: 0;\n        flex: 0 1 auto;\n        align-self: auto;\n        margin-bottom: 10px;\n      }\n      ion-fab {\n        position: relative;\n        display: block;\n        left: 0;\n        top: 0;\n      }\n      ion-fab-button,\n      .wm-btn-track-recording {\n        height: 42px;\n        width: 42px;\n        margin: 0 0 16px 10px;\n      }\n    }\n    > .bottom-center {\n      position: absolute;\n      right: 0;\n      left: 0;\n      bottom: 40px;\n      display: inline-flex;\n      flex-direction: column;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: center;\n      z-index: 2;\n      > * {\n        order: 0;\n        flex: 0 1 auto;\n        align-self: auto;\n        margin-bottom: 10px;\n      }\n      ion-fab {\n        position: relative;\n      }\n      ion-fab-button,\n      .wm-btn-track-recording {\n        height: 42px;\n        width: 42px;\n        margin: 7px;\n      }\n    }\n    > .bottom {\n      position: absolute;\n      right: 0;\n      left: 0;\n      bottom: 4px;\n      z-index: 2;\n      display: inline-flex;\n      flex-direction: row-reverse;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: flex-start;\n      > * {\n        order: 0;\n        flex: 0 1 auto;\n        align-self: auto;\n        margin-left: 10px;\n      }\n    }\n    > .top-right {\n      position: absolute;\n      right: calc(16px + constant(safe-area-inset-right));\n      right: calc(16px + env(safe-area-inset-right));\n      top: calc(16px + constant(safe-area-inset-top));\n      top: calc(16px + env(safe-area-inset-top));\n      z-index: 2;\n      display: inline-flex;\n      flex-direction: row-reverse;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: flex-start;\n      > *:not(:empty) {\n        order: 0;\n        flex: 0 1 auto;\n        align-self: auto;\n        margin-left: 10px;\n      }\n    }\n    > .top-left {\n      position: absolute;\n      left: 22px;\n      top: constant(safe-area-inset-top, 30px); // for ios 11.1\n      top: env(safe-area-inset-top, 30px); // for ios 11.2 and onwards\n      z-index: 2;\n      display: inline-flex;\n      flex-direction: row-reverse;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: flex-start;\n      > * {\n        order: 0;\n        flex: 0 1 auto;\n        align-self: auto;\n        margin-left: 10px;\n      }\n    }\n    .wm-map-delete-bounding-box-button {\n      width: 40px;\n      height: 40px;\n      margin: 0;\n      --background: var(--wm-color-light);\n      --border-radius: 20px;\n      --padding-start: 10px;\n      --padding-end: 10px;\n      animation: slideIn 0.3s ease-out;\n    }\n    .ol-zoom {\n      position: absolute;\n      top: 50%;\n      right: 20px;\n      left: 16px;\n      width: fit-content;\n      height: auto;\n      box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);\n      border-radius: 20px;\n      overflow: hidden;\n\n      button {\n        margin: 0;\n        height: 40px;\n        width: 40px;\n        font-size: 28px;\n\n        &:hover,\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n    #webmapp-map-scale-line-container {\n      position: absolute;\n      bottom: 11px;\n      left: 0;\n      width: 100px;\n      z-index: 1;\n    }\n    #webmapp-map-attribution-container {\n      position: absolute;\n      bottom: 20px;\n      right: 4px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 5px 10px;\n      border-radius: 5px;\n      transition: bottom 500ms;\n      z-index: 1;\n      background: rgba(var(--wm-color-light-rgb), 0.75);\n      box-shadow: -1px -1px 5px -3px var(--wm-color-dark);\n      .webmapp-map-attribution {\n        display: inline-block;\n        font-size: var(--font-sm);\n        .webmapp-map-attribution-link {\n          --ion-margin: 6px;\n          color: var(--wm-color-dark);\n          text-decoration: none;\n        }\n      }\n    }\n  }\n  canvas {\n    position: absolute;\n  }\n}\n\n@keyframes slideIn {\n  0% {\n    transform: translateY(15px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
